// App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import { ProductProvider } from './context/ProductContext';

import ProductListing from './pages/ProductListing';
import ProductDetail from './pages/ProductDetail';
import STOKLandingPage from './pages/STOKLanding';
import NotFound from './pages/NotFound';

import packageJson from '../package.json';

// Create a custom head script that will help with debugging routes
const addHeadDebugScript = () => {
  if (process.env.NODE_ENV === 'development') {
    const script = document.createElement('script');
    script.innerHTML = `
      (function() {
        console.log('Current location:', window.location.pathname);
        const meta = document.createElement('meta');
        meta.name = 'x-current-path';
        meta.content = window.location.pathname;
        document.head.appendChild(meta);
      })();
    `;
    document.head.appendChild(script);
  }
};

function App() {
  // Only in development
  if (process.env.NODE_ENV === 'development') {
    addHeadDebugScript();
  }

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <main className="flex-grow">
            <ProductProvider>
              <CartProvider>
                <Routes>
                  <Route path="/" element={<STOKLandingPage />} />
                  <Route path="/:share_code" element={<ProductListing />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </CartProvider>
            </ProductProvider>
          </main>
          <footer className="py-2 text-center">
            <span
              className="text-[10px] text-gray-400 font-mono select-none"
              aria-hidden
            >
              v{packageJson.version}
            </span>
          </footer>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;